<template>
  <div>
    <component v-bind:is="currentView" v-bind="$attrs" :taskVersion="taskVersion" v-on="$listeners" ></component>
  </div>
</template>

<script>
import V1D0 from './version/v1.0/index.vue';

export default {
  name: 'YxtbizNewUlcdSelect',
  components: {
    V1D0
  },
  props: {
    taskVersion: {
      type: String,
      default: '1.0'
    }
  },
  data() {
    return {
      currentView: 'V1D0'
    };
  },
  watch: {
    taskVersion: {
      handler(nval, oval) {
        console.log(this.$options.components);
        if (nval) {
          let cName = nval.indexOf('v') === 0 ? nval : `v${nval}`;
          cName = cName.toUpperCase().replace(/[.]/ig, 'D');
          const { components } = this.$options;
          if (components[cName]) { this.currentView = cName; } else {
            this.currentView = 'V1D0';
          }
        }
      },
      immediate: true
    }
  }
};
</script>
